import { render, staticRenderFns } from "./TierList.vue?vue&type=template&id=765a7df8&scoped=true&"
import script from "./TierList.vue?vue&type=script&lang=js&"
export * from "./TierList.vue?vue&type=script&lang=js&"
import style0 from "./TierList.vue?vue&type=style&index=0&id=765a7df8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a7df8",
  null
  
)

export default component.exports